"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Select: true
};
exports.default = exports.Select = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _isPrintableKeyEvent = _interopRequireDefault(require("is-printable-key-event"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _focusManager = require("../utils/focusManager");
var _ValidationMessage = require("../Forms/_ValidationMessage");
var _SelectField = require("../FormField/_SelectField");
var _Icon = require("../Icon/Icon");
var _Listbox = require("../List/Listbox");
var _Overlay = require("../Overlay/Overlay");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _listOptions = require("../utils/_listOptions");
var _listboxUtils = require("../List/_listboxUtils");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = require("../utils/isFunction");
var _Select = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Select.css") : void 0);
var _Select2 = require("./Select.types");
Object.keys(_Select2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Select2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Select2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/no-array-index-key */

const CSS_BLOCK = 'sapcnqr-select';
const KEYSTROKE_TIMEOUT = 500;
/** The **Select** component is used to gather input from a user.
 * It is similar in functionality to a `<select>` element.
 */
const Select = exports.Select = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  var _a;
  const [keyStrokes, setKeyStrokes] = (0, _react.useState)('');
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Select, _props)) : _props;
  const {
      controlProps,
      controlRef,
      disabled,
      decorators,
      emptyAriaLabel,
      groupBy,
      inputProps,
      includeEmptyOption,
      isMultiSelect,
      itemKey = 'key',
      itemText = 'text',
      dataRendering = {
        inputRenderer: itemText,
        listItemRenderer: itemText
      },
      labelProps,
      listboxProps,
      listItemProps,
      maxHeight = '30vh',
      mruOptions = [],
      mruTitle,
      onClick,
      onBlur,
      onChange,
      onFocus,
      onSelect,
      onSelectionChange,
      onDropdownClose,
      onDropdownOpen,
      options = [],
      optionsRef,
      otherGroupHeader,
      placeholder,
      overlayProps,
      readOnly,
      required,
      selectedKey,
      selectedKeys,
      validationMessage,
      inToolbarOverflow
    } = props,
    otherProps = __rest(props, ["controlProps", "controlRef", "disabled", "decorators", "emptyAriaLabel", "groupBy", "inputProps", "includeEmptyOption", "isMultiSelect", "itemKey", "itemText", "dataRendering", "labelProps", "listboxProps", "listItemProps", "maxHeight", "mruOptions", "mruTitle", "onClick", "onBlur", "onChange", "onFocus", "onSelect", "onSelectionChange", "onDropdownClose", "onDropdownOpen", "options", "optionsRef", "otherGroupHeader", "placeholder", "overlayProps", "readOnly", "required", "selectedKey", "selectedKeys", "validationMessage", "inToolbarOverflow"]);
  const classnames = _bind.default.bind(_Select.default);
  const internalComboboxRef = (0, _react.useRef)(null);
  const listboxRef = (0, _react.useRef)(null);
  const popperBodyRef = (0, _react.useRef)(null);
  const popperId = (0, _useUniqueId.default)();
  const uniqueListId = (0, _useUniqueId.default)();
  let listboxId = uniqueListId;
  if (listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.id) {
    listboxId = listboxProps.id;
  }
  let labelId = `label-${(0, _useUniqueId.default)()}`;
  if (otherProps === null || otherProps === void 0 ? void 0 : otherProps.id) {
    labelId = `label-${otherProps.id}`;
  }
  if (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) {
    labelId = labelProps.id;
  }
  const [selectedOptionKey, setSelectedOptionKey] = (0, _react.useState)(selectedKey);
  const [selectedOptionKeys, setSelectedOptionKeys] = (0, _react.useState)(selectedKeys !== null && selectedKeys !== void 0 ? selectedKeys : []);
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const displayOptions = includeEmptyOption ? [{
    attributes: {
      'aria-label': emptyAriaLabel
    }
  }, ...options] : options;
  const selected = displayOptions.find(option => typeof selectedOptionKey !== 'undefined' && (0, _listboxUtils.reduceOption)(option, itemKey) === selectedOptionKey);
  const findKeystrokeMatch = () => {
    if (!keyStrokes || !Array.isArray(options) || (0, _listboxUtils.matcherMethodIgnoreCase)((0, _listboxUtils.reduceOption)(selected, itemText), keyStrokes)) return null;
    return options.filter(option => {
      var _a;
      return !((_a = option === null || option === void 0 ? void 0 : option.attributes) === null || _a === void 0 ? void 0 : _a.disabled) && !(option === null || option === void 0 ? void 0 : option.disabled);
    }).filter(option => !(option === null || option === void 0 ? void 0 : option.divider)).find(option => {
      var _a;
      const optionText = (_a = (0, _listboxUtils.reduceOption)(option, itemText)) === null || _a === void 0 ? void 0 : _a.trim();
      return optionText && (keyStrokes === null || keyStrokes === void 0 ? void 0 : keyStrokes.trim()) && (0, _listboxUtils.matcherMethodIgnoreCase)(optionText, keyStrokes);
    });
  };
  const handleOnSelect = (event, optionKey, selectedOption) => {
    var _a;
    setSelectedOptionKey(optionKey);
    setIsExpanded(false);
    (_a = internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(event, optionKey, selectedOption);
  };
  const handleOnSelectionChange = (event, optionKey, isSelected, option) => {
    if (isSelected) {
      // add it to the array
      setSelectedOptionKeys([...selectedOptionKeys, optionKey]);
    } else {
      // remove it from the array
      setSelectedOptionKeys(selectedOptionKeys.filter(someOptionKey => someOptionKey !== optionKey) || []);
    }
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(event, optionKey, isSelected, option);
  };
  const tryToSelectOption = () => {
    const foundOption = findKeystrokeMatch();
    const foundOptionKey = (0, _listboxUtils.reduceOption)(foundOption, itemKey);
    if (foundOptionKey) {
      handleOnSelect(undefined, foundOptionKey, foundOption);
    }
  };
  const clearKeys = () => {
    setKeyStrokes('');
  };
  let keyTimeout;
  const startTimer = () => {
    if ((0, _isFunction.isFunction)(setTimeout)) {
      keyTimeout = setTimeout(clearKeys, KEYSTROKE_TIMEOUT);
    }
  };
  const resetTimer = () => {
    if ((0, _isFunction.isFunction)(clearTimeout)) {
      clearTimeout(keyTimeout);
    }
  };
  (0, _react.useEffect)(() => {
    resetTimer();
    if (keyStrokes === null || keyStrokes === void 0 ? void 0 : keyStrokes.trim()) {
      if (!isExpanded) {
        tryToSelectOption();
      }
      startTimer();
    }
    return () => {
      clearTimeout(keyTimeout);
    };
  }, [keyStrokes, options]);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (isMultiSelect && selectedKeys) {
      setSelectedOptionKeys(selectedKeys);
    } else {
      setSelectedOptionKey(selectedKey);
    }
  }, [selectedKey, selectedKeys, options]);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (isExpanded) {
      onDropdownOpen === null || onDropdownOpen === void 0 ? void 0 : onDropdownOpen();
    } else {
      onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
    }
  }, [isExpanded]);
  const attachFocusManager = () => {
    if (popperBodyRef === null || popperBodyRef === void 0 ? void 0 : popperBodyRef.current) {
      // eslint-disable-next-line no-new
      new _focusManager.FocusManager({
        trapNode: popperBodyRef === null || popperBodyRef === void 0 ? void 0 : popperBodyRef.current
      });
    }
  };
  const queueFocusManagerAttachment = () => {
    setTimeout(() => {
      attachFocusManager();
    }, 0);
  };
  const openPopoverToIndex = () => {
    setIsExpanded(true);
    queueFocusManagerAttachment();
  };
  const handleClick = e => {
    if (!disabled && !readOnly) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
      if (!isExpanded) {
        openPopoverToIndex();
      } else {
        setIsExpanded(false);
      }
    }
  };
  const handleFocus = e => {
    if (disabled) {
      return;
    }
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  };
  const tryToOpen = event => {
    event.preventDefault();
    if (!disabled && !readOnly) {
      if (!isExpanded) {
        openPopoverToIndex();
      }
    }
  };
  const handleKeyDown = event => {
    var _a, _b;
    if (readOnly || disabled) {
      return;
    }
    switch ((0, _keycode.default)(event)) {
      case 'enter':
        tryToOpen(event);
        break;
      case 'down':
        // in toolbar overflow, pressing down key on a select does nothing
        // down key is used for navigating through the overflow menu
        if (inToolbarOverflow) return;
        if (!disabled && !readOnly && !isExpanded) {
          openPopoverToIndex();
          event.preventDefault();
        }
        break;
      case 'space':
        if (keyStrokes) {
          setKeyStrokes(`${keyStrokes} `);
        } else {
          tryToOpen(event);
        }
        break;
      default:
        if (
        // if control/command key is pressed, don't add to keyStrokes
        // eg. Crl+C, Cmd+C
        !event.ctrlKey && !event.metaKey && (0, _isPrintableKeyEvent.default)(event)) {
          event.stopPropagation();
          const nextKeyStroke = ((_b = (_a = (0, _keycode.default)(event)) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, 'numpad ', '')) || '';
          setKeyStrokes(keyStrokes + nextKeyStroke);
        }
        break;
    }
  };
  const handleBlur = e => {
    if (disabled) {
      return;
    }
    if (!isExpanded) {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }
  };
  const handleOptionKeyDown = event => {
    if ((0, _keycode.default)(event) === 'tab') {
      event.stopPropagation();
      setIsExpanded(false);
    }
  };
  const renderInputValue = () => isMultiSelect ? (0, _listOptions.renderMultiInputValue)({
    options,
    itemKey,
    inputRenderer: dataRendering === null || dataRendering === void 0 ? void 0 : dataRendering.inputRenderer,
    selectedOptionKeys
  }) : (0, _listOptions.renderSingleInputValue)({
    options,
    itemKey,
    inputRenderer: dataRendering === null || dataRendering === void 0 ? void 0 : dataRendering.inputRenderer,
    selectedOptionKey
  });
  const inputValue = renderInputValue();
  let controlAriaProps = {};
  if (!disabled && !readOnly) {
    controlAriaProps = {
      role: 'combobox',
      'aria-haspopup': 'listbox',
      'aria-expanded': isExpanded,
      'aria-controls': isExpanded ? listboxId : null,
      'aria-required': required,
      tabIndex: 0 // make combobox focusable
      // for JAWS to be able to detect the field in forms mode
    };
  }
  const getInputEndDecorators = () => {
    const decoratorArray = [];
    if (!readOnly) {
      decoratorArray.push(/*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        ariaHidden: true,
        iconName: "navigation-down-arrow"
      }));
    }
    return [..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputEnd), ...decoratorArray];
  };
  const renderInputField = popperTargetRef => (/*#__PURE__*/_react.default.createElement(_SelectField.SelectField, Object.assign({}, otherProps, {
    controlProps: Object.assign(Object.assign(Object.assign({}, controlProps), controlAriaProps), {
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown
    }),
    onClick: handleClick,
    controlRef: (0, _reactMergeRefs.default)([popperTargetRef, controlRef, internalComboboxRef]),
    disabled: disabled,
    labelProps: Object.assign(Object.assign({}, labelProps), {
      id: labelId
    }),
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    ref: ref,
    decorators: Object.assign(Object.assign({}, decorators), {
      inputEnd: getInputEndDecorators()
    }),
    emptyAriaLabel: includeEmptyOption && !inputValue && !placeholder ? emptyAriaLabel : undefined,
    inputProps: inputProps,
    validationMessage: validationMessage,
    value: inputValue,
    isRenderedValue: (0, _isFunction.isFunction)(dataRendering === null || dataRendering === void 0 ? void 0 : dataRendering.inputRenderer)
  })));
  const keepFocusOnPressTab = event => {
    var _a;
    if ((0, _keycode.default)(event) === 'tab') {
      (_a = internalComboboxRef === null || internalComboboxRef === void 0 ? void 0 : internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  };
  const {
    isUsingGroups,
    newOptions,
    groupLabelRenderer
  } = (0, _listOptions.getOptionsList)({
    options: displayOptions,
    mruOptions,
    groupBy,
    mruTitle,
    otherGroupHeader
  });
  let optionsRefChecked;
  let listboxRefChecked;
  if (optionsRef) {
    optionsRefChecked = optionsRef;
  }
  if (listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.ref) {
    listboxRefChecked = listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.ref;
  }
  return /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, Object.assign({}, overlayProps, {
    onShow: (0, _chainFunction.default)(() => setIsExpanded(true), overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onShow),
    onHide: (0, _chainFunction.default)(() => setIsExpanded(false), overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onHide),
    onClickOutside: (0, _chainFunction.default)(event => {
      var _a, _b;
      return !!((event === null || event === void 0 ? void 0 : event.target) === (internalComboboxRef === null || internalComboboxRef === void 0 ? void 0 : internalComboboxRef.current) || ((_b = (_a = internalComboboxRef === null || internalComboboxRef === void 0 ? void 0 : internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, event === null || event === void 0 ? void 0 : event.target)));
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside),
    onEscapeKey: () => {
      var _a;
      (_a = internalComboboxRef === null || internalComboboxRef === void 0 ? void 0 : internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    },
    onKeyDown: keepFocusOnPressTab,
    popperPlacement: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperPlacement) || ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
    popperProps: Object.assign(Object.assign({}, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      id: popperId,
      innerRef: (0, _reactMergeRefs.default)([popperBodyRef, optionsRefChecked]),
      role: 'presentation'
    }),
    show: isExpanded,
    renderTargetComponent: renderInputField,
    widthSizingType: (_a = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.widthSizingType) !== null && _a !== void 0 ? _a : 'minTarget',
    skipTargetModifications: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__popper-contents`)
  }, validationMessage && validationMessage.state && validationMessage.text && (/*#__PURE__*/_react.default.createElement(_ValidationMessage.ValidationMessage, {
    inPopper: true,
    state: validationMessage.state,
    text: validationMessage.text
  })), /*#__PURE__*/_react.default.createElement(_Listbox.Listbox, Object.assign({}, listboxProps, {
    id: listboxId,
    ariaLabelledby: labelId,
    className: classnames(`${CSS_BLOCK}__listbox`, listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.className),
    groupLabelRenderer: isUsingGroups ? groupLabelRenderer : undefined,
    hideOuterFocusRing: true,
    itemKey: itemKey,
    itemText: itemText,
    listItemProps: listItemProps,
    listItemRenderer: dataRendering === null || dataRendering === void 0 ? void 0 : dataRendering.listItemRenderer,
    maxHeight: maxHeight,
    onKeyDown: (0, _chainFunction.default)(handleOptionKeyDown, listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.onKeyDown),
    onChange: onChange,
    onSelect: handleOnSelect,
    onSelectionChange: handleOnSelectionChange,
    options: isUsingGroups ? newOptions : newOptions[0],
    ref: (0, _reactMergeRefs.default)([listboxRef, listboxRefChecked]),
    selectedKey: selectedOptionKey,
    selectedKeys: selectedOptionKeys,
    selectionType: isMultiSelect ? 'multiSelect' : 'singleSelectMaster'
  }))));
});
Select.displayName = 'Select';
var _default = exports.default = Select;